<template>
	<v-container>
		<v-row class="contentRow">
			<v-tabs
				v-model="selectedTab"
				background-color="transparent"
				light
				centered
				icons-and-text
			>
				<v-tab>
					Overview
					<v-icon>fas fa-users</v-icon>
				</v-tab>

				<v-tab>
					Requests
					<v-icon>fas fa-users-cog</v-icon>
				</v-tab>

				<v-tab>
					Invite
					<v-icon>fas fa-envelope</v-icon>
				</v-tab>
				<v-tab>
					Pending
					<v-icon>fas fa-clock</v-icon>
				</v-tab>
				<v-tab>
					Redeemed
					<v-icon>fas fa-check</v-icon>
				</v-tab>
				<v-tab>
					Search
					<v-icon>fas fa-magnifying-glass</v-icon>
				</v-tab>
				<v-tab-item>
					<br />
					<Connections :selected="selectedTab == 0" />
				</v-tab-item>
				<v-tab-item>
					<br />
					<ConnectionRequests :selected="selectedTab == 1" />
				</v-tab-item>
				<v-tab-item>
					<br />
					<v-btn
						@click="
							$store.dispatch(
								'connections/invitationcodes/setInvitationCodeModalOpen',
								true
							)
						"
					>
						Invite Supplier
						<v-icon small right>fas fa-envelope</v-icon>
					</v-btn>
					<AddNewInvitationCode />
					<NewCodeDisplay />
				</v-tab-item>
				<v-tab-item>
					<br />
					<InvitationCodes :selected="selectedTab == 3" />
				</v-tab-item>
				<v-tab-item>
					<br />
					<RedeemedInvitationCodes :selected="selectedTab == 4" />
				</v-tab-item>
				<v-tab-item>
					<br />
					<ConnectionSearch :selected="selectedTab == 5" :key="selectedTab"/>
				</v-tab-item>
			</v-tabs>
		</v-row>
	</v-container>
</template>

<script>
import Connections from "./Connections.vue"
import ConnectionRequests from "./ConnectionRequests.vue"
import ConnectionSearch from "./ConnectionSearch.vue"
import InvitationCodes from "./InvitationCodes.vue"
import RedeemedInvitationCodes from "./RedeemedInvitationCodes.vue"
import AddNewInvitationCode from "../../components/InvitationCodes/AddNew"
import NewCodeDisplay from "../../components/InvitationCodes/NewCodeDisplay"

export default {
	name: "ConnectionsOverview",
	components: {
		Connections,
		ConnectionRequests,
		InvitationCodes,
		RedeemedInvitationCodes,
		ConnectionSearch,
		AddNewInvitationCode,
		NewCodeDisplay,
	},
	data() {
		return {
			dialog: false,
			addNewDialog: false,
			selectedTab: 0,
		}
	},
	watch: {
		selectedTab(newTab) {
			if (newTab === 5) {
				// Force the ConnectionSearch component to reload
				this.$nextTick(() => {
					this.$refs.connectionSearch?.resetComponent()
				})
			}
		},
	},
}
</script>
